module.exports = __webpack_public_path__ + "static/banner-3-0ec2157f6ee622e20ad83e24a3b17ddb.jpg";